import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

function LocationErrorDialog() {
  const reload = () => window.location.reload();

  return (
    <Dialog open={true}>
      <DialogTitle>Location Permission Required</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This app needs access to your location to show nearby public transport stops.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={reload} variant="contained">Retry</Button>
      </DialogActions>
    </Dialog>
  );
}

export default LocationErrorDialog;
